import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import index from '@/views/index/index' 
let router = new Router({
  mode: 'history', // 或者 'hash'
  routes: [
    {path: '/',name: 'index',component: index, meta:{title:"天台生活 - 本地社交平台"}},
    {path:"/privacyPolicy",name:"privacyPolicy",component:() => import('@/views/policy/privacyPolicy'),meta:{title:`"天台生活"隐私政策`}},  
    {path:"/userAgreement",name:"userAgreement",component:() => import('@/views/policy/userAgreement'),meta:{title:`"天台生活"用户服务协议`}},            //隐私协议
    {path:"/thirdPartySdk",name:"thirdPartySdk",component:() => import('@/views/policy/thirdPartySdk'),meta:{title:"第三方sdk列表"}},         //第三方sdk列表

    {path:"/article",name:"article",component:() => import('@/views/article/index'),meta:{title:"文章详情-天台生活",dynamic:true}},                 //帖子详情页
    {path:"/rentHouse",name:"rentHouse",component:() => import('@/views/house/rentHouse'),meta:{title:"租房页-天台生活",dynamic:true}},             //租房
    {path:"/sellHouse",name:"sellHouse",component:() => import('@/views/house/sellHouse'),meta:{title:"房产页-天台生活",dynamic:true}},             //房产
    


    {path:"/openApp",name:"openApp",component:() => import('@/views/openApp/index'),meta:{isMobile:true,title:"天台生活",dynamic:true}},            //打开app 
  ]
})

function setRem() {
    const designWidth = 750
    const baseFont = 100
    let width = window.innerWidth
    if (width > designWidth) width = designWidth
    document.documentElement.style.fontSize = width / designWidth * baseFont + 'px'
}

router.beforeEach((to, from, next) => {
    // 假设你在路由 meta 里标记移动端页面
    if (to.meta.isMobile) {
        setRem()
        window.addEventListener('resize', setRem)
        window.addEventListener('pageshow', e => { e.persisted && setRem() })
        document.body.classList.add('mobile-page')
    } else {
        document.body.classList.remove('mobile-page')
        document.documentElement.style.fontSize = '' // 取消 rem
        window.removeEventListener('resize', setRem)
        window.removeEventListener('pageshow', setRem)
    }
    next()
})

router.afterEach((to)=>{
    if(to.meta.dynamic){        //动态标题
        document.title = '加载中...'
    }else if(to.meta.title){    //固定标题
        document.title = to.meta.title
    }else{                      //默认标题
         document.title = '天台生活'
    }
})



export default router